module.exports = __webpack_public_path__ + "static/media/up-arrow.7f0b3ee6.svg";